import { AuthProtectedComponent } from '@statsbomb/kitbag-auth';
import PropTypes from 'prop-types';
import React from 'react';
import { CLAIMS_URI } from '../../AuthProvider';

export function Secured({ allowed, children }) {
  return (
    <AuthProtectedComponent
      allowed={allowed}
      claimsURI={CLAIMS_URI}
      customisedLogin={<></>}
    >
      {children}
    </AuthProtectedComponent>
  );
}

Secured.propTypes = {
  allowed: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
  children: PropTypes.node.isRequired,
};

export default { Secured };
